/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';

/**
 * 
 * @export
 * @interface EnveloppeTypeFinancementSearch
 */
export interface EnveloppeTypeFinancementSearch {
    /**
     * 
     * @type {StringListSearch}
     * @memberof EnveloppeTypeFinancementSearch
     */
    idanneeScolaire?: StringListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof EnveloppeTypeFinancementSearch
     */
    identite?: Int32ListSearch;
    /**
     * 
     * @type {number}
     * @memberof EnveloppeTypeFinancementSearch
     */
    idfinancementType?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnveloppeTypeFinancementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof EnveloppeTypeFinancementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof EnveloppeTypeFinancementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnveloppeTypeFinancementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof EnveloppeTypeFinancementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof EnveloppeTypeFinancementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the EnveloppeTypeFinancementSearch interface.
 */
export function instanceOfEnveloppeTypeFinancementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EnveloppeTypeFinancementSearchFromJSON(json: any): EnveloppeTypeFinancementSearch {
    return EnveloppeTypeFinancementSearchFromJSONTyped(json, false);
}

export function EnveloppeTypeFinancementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnveloppeTypeFinancementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idanneeScolaire': !exists(json, 'idanneeScolaire') ? undefined : StringListSearchFromJSON(json['idanneeScolaire']),
        'identite': !exists(json, 'identite') ? undefined : Int32ListSearchFromJSON(json['identite']),
        'idfinancementType': !exists(json, 'idfinancementType') ? undefined : json['idfinancementType'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function EnveloppeTypeFinancementSearchToJSON(value?: EnveloppeTypeFinancementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idanneeScolaire': StringListSearchToJSON(value.idanneeScolaire),
        'identite': Int32ListSearchToJSON(value.identite),
        'idfinancementType': value.idfinancementType,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

